import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { RequireLoggedOut } from "@/app/router";
import { LongevityLayout } from "../components";
import {
  AccountContactDetails,
  AccountPersonalDetails,
  LongevityCheckout,
} from "../screens";
import { LONGEVITY_ROUTE } from "./constants";

export const getLongevityRoute = (): RouteObject => ({
  path: LONGEVITY_ROUTE.BASE,
  element: (
    <RequireLoggedOut>
      <LongevityLayout />
    </RequireLoggedOut>
  ),
  children: [
    {
      path: LONGEVITY_ROUTE.ACCOUNT_PERSONAL_DETAILS,
      element: <AccountPersonalDetails />,
    },
    {
      path: LONGEVITY_ROUTE.ACCOUNT_CONTACT_DETAILS,
      element: <AccountContactDetails />,
    },
    {
      path: LONGEVITY_ROUTE.CHECKOUT,
      element: <LongevityCheckout />,
    },
    {
      index: true,
      element: (
        <Navigate replace to={LONGEVITY_ROUTE.ACCOUNT_PERSONAL_DETAILS} />
      ),
    },
    {
      path: "*",
      element: (
        <Navigate replace to={LONGEVITY_ROUTE.ACCOUNT_PERSONAL_DETAILS} />
      ),
    },
  ],
});
